import styles from './toaster.module.css'

const Toaster = () => (
  <div id="toast-container" className={styles.container} aria-live="polite" />
)

export { Toaster }
